import { useEffect } from 'react';

/** Keep the dashboard from shrinking with the mobile keyboard; lift focused fields. */
export function useMobileKeyboardLayout() {
    useEffect(() => {
        const root = document.documentElement;

        const sync = () => {
            const vv = window.visualViewport;
            const layoutH = window.innerHeight || 0;
            const visH = vv ? vv.height : layoutH;
            const kb = Math.max(0, Math.round(layoutH - visH - (vv ? vv.offsetTop : 0)));
            root.style.setProperty('--tbx-kb', `${kb}px`);
            root.style.setProperty('--tbx-vvh', `${Math.round(visH)}px`);
            root.classList.toggle('tbx-keyboard-open', kb > 80);
        };

        const onFocusIn = (event) => {
            const el = event.target;
            if (!(el instanceof HTMLElement)) return;
            if (!el.matches('input, textarea, select, [contenteditable="true"]')) return;
            sync();
            window.setTimeout(() => {
                try {
                    el.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'smooth' });
                } catch (e) {
                    el.scrollIntoView(true);
                }
            }, 280);
        };

        const vv = window.visualViewport;
        window.addEventListener('resize', sync);
        vv?.addEventListener('resize', sync);
        vv?.addEventListener('scroll', sync);
        document.addEventListener('focusin', onFocusIn);
        document.addEventListener('focusout', sync);
        sync();

        return () => {
            window.removeEventListener('resize', sync);
            vv?.removeEventListener('resize', sync);
            vv?.removeEventListener('scroll', sync);
            document.removeEventListener('focusin', onFocusIn);
            document.removeEventListener('focusout', sync);
            root.classList.remove('tbx-keyboard-open');
            root.style.removeProperty('--tbx-kb');
        };
    }, []);
}
